import { Navigate, Outlet, useLocation } from "react-router-dom";
import { readClientSession } from "utils/clientSession";

export default function RequireClient() {
  const location = useLocation();
  const session = readClientSession();
  const devWithoutAuth = process.env.NODE_ENV === "development";

  if (!session && !devWithoutAuth) {
    const returnTo = `${location.pathname}${location.search}`;
    return (
      <Navigate
        to={`/SignIn?returnTo=${encodeURIComponent(returnTo)}`}
        replace
      />
    );
  }

  return <Outlet />;
}
